import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useStore } from '../contexts/StoreContext';
import { Vehicle } from '../types/catalog';
import { buildWhatsAppUrl } from '../utils/validation';
import { vehicleLabel } from '../utils/catalog';
interface WhatsAppButtonProps {
  vehicle?: Vehicle;
  extra?: string;
  iconOnly?: boolean;
  className?: string;
}
export function WhatsAppButton({
  vehicle,
  extra,
  iconOnly,
  className = ''
}: WhatsAppButtonProps) {
  const {
    settings,
    brands,
    addLead
  } = useStore();
  const onClick = () => {
    if (!settings.whatsapp) {
      toast.error('El WhatsApp comercial todavía no está configurado.', {
        description: 'Podés dejarnos tu consulta con el formulario y un asesor te contactará.'
      });
      return;
    }
    const label = vehicle ? vehicleLabel(vehicle, brands) : null;
    const text = [`Hola VCARS, quiero asesoramiento${label ? ` sobre el ${label}` : ' para mi 0 km'}.`, extra].filter(Boolean).join(' ');
    addLead({
      channel: 'whatsapp',
      name: 'Sin identificar (WhatsApp)',
      phone: '',
      email: '',
      contactPref: 'whatsapp',
      vehicleId: vehicle?.id ?? null,
      vehicleLabel: label,
      price: vehicle?.price ?? null,
      down: null,
      term: null,
      simulation: null,
      message: text,
      credit: null,
      consents: {
        dataProcessing: false,
        contact: false,
        at: new Date().toISOString()
      }
    });
    window.open(buildWhatsAppUrl(settings.whatsapp, text), '_blank', 'noopener,noreferrer');
  };
  return <button type="button" onClick={onClick} className={`btn btn-wa ${iconOnly ? 'w-11 px-0' : ''} ${className}`} aria-label="Consultar por WhatsApp" data-id="element-1176" data-mp="3us7p8vipzavh">
      <MessageCircleIcon className="h-4 w-4" aria-hidden data-id="element-1177" data-mp="3ebn8bv1ukld" />
      {!iconOnly && 'Consultar por WhatsApp'}
    </button>;
}